import { createReducer, createSelector, on } from '@ngrx/store';
import { AppState } from '../store';
import { LoadUserFailure, LoadUserSuccess, LogoutFailure, LogoutSuccess } from '../actions/user.actions';
import { environment } from 'src/environments/environment';
import { UserView } from '@iota/inh-core-v1-management-client';

export interface UserState {
    userLoaded: boolean;
    user: UserView;
    error: any;
}

export const initialState: UserState = {
    userLoaded: false,
    user: undefined,
    error: undefined
};

export const userReducer = createReducer(
    initialState,

    on(LoadUserSuccess, (state, { user }) => ({ ...state, user, userLoaded: true })),
    on(LoadUserFailure, (state, { error }) => ({ ...state, user: undefined, error, userLoaded: true })),

    on(LogoutSuccess, (state) => ({ ...state, user: undefined })),
    on(LogoutFailure, (state, { error }) => ({ ...state, error }))
);

export const userState = (state: AppState) => state.userState;
export const user = createSelector(userState, (state) => state.user);
export const userLoaded = createSelector(userState, (state) => state.userLoaded);
export const isIotaAdmin = createSelector(user, (user) => user && user.roles && new Set(user.roles).has(environment.iotaAdminRole));
export const isMgmtAdmin = createSelector(user, (user) => user && user.roles && new Set(user.roles).has(environment.adminRole));
export const isAllowed = createSelector(user, (user) => user && user.roles && new Set(user.roles).has(environment.requiredRole));
